<script lang="ts" setup>
import { ref, Ref } from 'vue'
import { useDialogPluginComponent, Notify } from 'quasar'
import { GeneratedDocument } from '@/models/files/GeneratedDocument'
import { useApi } from '@/store/useAppStore'
import UserApi from '@/services/api/core/UserApi'
import BaseDialog from '@/components/base/BaseDialog.vue'

interface Props {
  node: any
}
const props = defineProps<Props>()

const userApi: UserApi = useApi()
const isLoading: Ref<boolean> = ref(false)

const emit = defineEmits([...useDialogPluginComponent.emits])
const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

async function confirmReimport() {
  emit('ok')
}
</script>

<template>
  <q-dialog ref="dialogRef">
    <BaseDialog title="Import en double" :is-dialog-loading="isLoading" @on-dialog-cancel="onDialogCancel()"
      @hide="onDialogHide()">
      <template #body>Ce dossier LOP a déjà été importé. Êtes-vous sûr de vouloir le ré-importer ? </template>
      <template #actions>
        <q-btn flat label="Confirmer" @click="confirmReimport()" color="negative" />
      </template>
    </BaseDialog>
  </q-dialog>
</template>
<style lang="scss" scoped></style>
